import { useEffect, useState } from 'react'
import firebase from '../firebase/compat'

// Alle betalende organisaties met hun abonnement, via de callable
// getSubscriptionsOverview. Geen Firestore-listener: `Subscriptions` staat op
// isTeam(), dus de beheertenant zou in de browser een LEGE lijst krijgen —
// geen fout, gewoon niets. Zie docs/features/subscriptions-overview-page.md
//
// `error` blijft staan als de aanroep faalt: stil terugvallen op een lege lijst
// zou er op het scherm uitzien als "er zijn geen organisaties".
//
// AI-CONTEXT: See docs/features/subscriptions-overview-page.md

/**
 * @returns {{rows: Array<object>, loading: boolean, error: string|null, replaceRow: (row: object) => void}}
 */
const useSubscriptionsOverview = () => {
    const [rows, setRows] = useState(/** @type {Array<object>} */ ([]))
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(/** @type {string | null} */ (null))

    useEffect(() => {
        let cancelled = false

        const fetch = async () => {
            try {
                // v2-functie in europe-west1 — region expliciet, anders belt de
                // SDK us-central1 en bestaat de functie daar niet.
                const getSubscriptionsOverview = firebase.app().functions('europe-west1')
                    .httpsCallable('getSubscriptionsOverview')
                const result = await getSubscriptionsOverview({})
                if (cancelled) return
                setRows(Array.isArray(result.data?.rows) ? result.data.rows : [])
            } catch (err) {
                console.error('useSubscriptionsOverview error:', err)
                if (cancelled) return
                setError(err.message || 'Kon het abonnementenoverzicht niet ophalen.')
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        fetch()
        return () => { cancelled = true }
    }, [])

    /**
     * Eén rij bijwerken na een geslaagde opslag — bewust NIET de hele lijst
     * opnieuw ophalen. Bij ~94 in te vullen rijen ben je er meerdere tegelijk
     * aan het typen, en een verversing zou die andere concepten wissen.
     *
     * @param {object} updated - de vervangende rij
     */
    const replaceRow = (updated) => {
        setRows((current) => current.map((row) =>
            row.compagnyId === updated.compagnyId ? { ...row, ...updated } : row))
    }

    return { rows, loading, error, replaceRow }
}

export default useSubscriptionsOverview
